import React from 'react';

export default function ShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      fill="none"
      viewBox="0 0 22 23"
    >
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M17.333 4L10 11.333M17.333 4l-4.666 13.333-2.667-6-6-2.666L17.333 4z"
      ></path>
    </svg>
  );
}